'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Auth';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import Logo from 'Pure/Logo';
import Link from 'Pure/Link';
export default class NotFoundPage extends Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Page introuvable"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "login-page__left"
    }, /*#__PURE__*/React.createElement("div", {
      className: "u-full-width"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "auth-logo-link",
      href: "/"
    }, /*#__PURE__*/React.createElement(Logo, {
      style: {
        width: '240px',
        maxWidth: '100%',
        margin: 'auto'
      }
    })), getFormStatus({
      error: 'Votre page n\'a pas été trouvée. ' + '(Erreur 404).'
    }), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-flex u-content-center"
    }, /*#__PURE__*/React.createElement(Link, {
      href: "/",
      className: "home-link u-width-auto"
    }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
      className: "u-margin-right-10"
    }), " Retourner sur le site myWO")))), /*#__PURE__*/React.createElement("div", {
      className: "login-page__right"
    }, /*#__PURE__*/React.createElement("div", {
      className: "u-full-width"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "login-page__title"
    }, "Page introuvable"))));
    return output;
  }
}
